import { type FC } from 'react';
import type { NodeProps } from 'reactflow';
import type { NodeData } from '@/types/node.types';
import BaseNode from './BaseNode';

const RESOURCE_COLOR = '#6B7280';

export const ResourceNode: FC<NodeProps<NodeData>> = ({ id, data, selected }) => {
  return <BaseNode id={id} data={data} color={RESOURCE_COLOR} icon={'\u2699'} selected={selected} />;
};

export default ResourceNode;
